import { Anchor, Badge, Box, Card, Group, Text } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { formatMoney } from "../../constants/operatorListConstants";
import { dummyLogo } from "../../../../utils/dummyLogo";
import callIcon from "../../../../assets/svg/call_icon.svg";
import emailIcon from "../../../../assets/svg/email_icon.svg";
import operatorWalletChipIcon from "../../../../assets/svg/operator_wallet_chip.svg";

const OperatorHeader = ({ operator }) => {
  const isCompact = useMediaQuery("(max-width: 48em)");
  /** One 24px column (12px on narrow screens) — must match tabs + table area, not outer Box + 24 again. */
  const inset = isCompact ? 12 : 24;
  const nameLeft = inset + 100;
  const walletBalance =
    Number(
      operator?.wallet_balance ?? operator?.wallet ?? operator?.wallet_amount
    ) || 0;

  const status =
    operator?.status || (operator?.is_active === false ? "Suspended" : "Active");
  const isActive = String(status).toLowerCase() === "active";

  return (
    <Box px={{ base: 12, sm: 0 }} pt={8} pb={12} style={{ position: "relative" }}>
      <Group
        align="stretch"
        gap={isCompact ? 16 : 24}
        wrap={isCompact ? "wrap" : "nowrap"}
        pr={{ base: 0, sm: 24 }}
        h={isCompact ? "auto" : 244}
       
      >
        <Card
        radius={8}
        withBorder={false}
        style={{
          flex: isCompact ? "1 1 100%" : "1 1 0%",
          minWidth: 0,
          width: isCompact ? "100%" : undefined,
          minHeight: 244,
          padding: 0,
          background: "#FFFFFF",
          position: "relative",
        }}
      >
        <Box style={{ position: "absolute", left: inset, top: 24, width: 84, height: 64, borderRadius: 8, background: "#fff", border: "1px solid rgba(9,44,76,0.08)", overflow: "hidden" }}>
          <img
            src={operator?.logo || dummyLogo}
            alt={operator?.operator_name || "Operator"}
            style={{ width: "100%", height: "100%", objectFit: "contain", padding: "10px 3px" }}
          />
        </Box>

        <Text
          fw={600}
          fz={20}
          c="#092C4C"
          style={{
            position: "absolute",
            left: nameLeft,
            top: 24,
            right: 100,
            width: "auto",
            maxWidth: isCompact ? undefined : 260,
            lineHeight: "normal",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {operator?.operator_name}
        </Text>
        <Text
          fz={14}
          c="#6C94B4"
          lh="18px"
          style={{
            position: "absolute",
            left: nameLeft,
            top: 52,
            right: 24,
            width: "auto",
            maxWidth: isCompact ? undefined : 300,
            ...(isCompact
              ? {
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  whiteSpace: "normal",
                }
              : {
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }),
          }}
        >
          {operator?.operator.address}
        </Text>

        <Badge
          radius={4}
          variant="filled"
          styles={{
            root: {
              position: "absolute",
              right: 24,
              top: 26,
              width: 72,
              justifyContent: "center",
              background: isActive ? "#D5FADE" : "#FD4A63",
              color: isActive ? "#3AC65E" : "#FFFFFF",
              fontSize: 10,
              fontWeight: 600,
              paddingInline: 12,
              paddingBlock: 4,
            },
          }}
        >
          {status}
        </Badge>

        <Text
          fz={14}
          fw={600}
          style={{
            position: "absolute",
            left: inset,
            top: 104,
            lineHeight: "18px",
            color: "transparent",
            backgroundImage: "linear-gradient(to left, #0053A8, #033F7C)",
            WebkitBackgroundClip: "text",
            backgroundClip: "text",
          }}
        >
          {operator?.operator.operator_type}
        </Text>

        <Box w={24} h={24} style={{ position: "absolute", left: inset, top: 134 }}>
          <img src={callIcon} alt="" width={24} height={24} />
        </Box>
        <Text
          fz={14}
          fw={500}
          c="#6C94B4"
          lh="18px"
          style={{
            position: "absolute",
            left: inset + 36,
            right: 24,
            top: 137,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {operator?.operator.phone_number}
        </Text>

        <Box w={24} h={24} style={{ position: "absolute", left: inset, top: 168 }}>
          <img src={emailIcon} alt="" width={24} height={24} />
        </Box>
        <Text
          fz={14}
          fw={500}
          c="#6C94B4"
          lh="18px"
          style={{
            position: "absolute",
            left: inset + 36,
            right: 24,
            top: 171,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {operator?.operator.email}
        </Text>

        <Group gap={4} wrap="wrap" style={{ position: "absolute", left: inset, right: 24, top: 206 }}>
          <Text fz={14} fw={500} c="#6C94B4" lh="18px">
            Operator Code :
          </Text>
          <Anchor
            fz={14}
            fw={600}
            underline="never"
            href="#"
            style={{
              color: "transparent",
              backgroundImage: "linear-gradient(to left, #0053A8, #033F7C)",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              lineHeight: "18px",
            }}
          >
            {operator?.operator_code || "ASC360-OPP-0075"}
          </Anchor>
        </Group>
      </Card>

      <Card
        radius={12}
        style={{
          flex: isCompact ? "1 1 100%" : "0 0 auto",
          width: isCompact ? "100%" : 248,
          
          height: 156,
          marginTop: isCompact ? 0 : 44,
          alignSelf: isCompact ? "stretch" : undefined,
          background:
            "linear-gradient(236.209deg, rgb(0, 115, 192) 0%, rgb(50, 165, 243) 100%)",
          color: "#FFFFFF",
          padding: 0,
          position: "relative",
          overflow: "hidden",
        }}
      >
        <Box
          style={{
            position: "absolute",
            left: 0,
            bottom: 0,
            width: isCompact ? "100%" : 248,
            height: 46,
            background:
              "linear-gradient(180deg, rgba(255,255,255,0.15) 0%, rgba(255,255,255,0) 100%)",
          }}
        />

        <img
          src={operatorWalletChipIcon}
          alt=""
          style={{ position: "absolute", left: 16, top: 16, width: 32, height: 20 }}
        />

        <Text
          style={{
            position: "absolute",
            right: 24,
            top: 16,
            fontSize: 18,
            lineHeight: "22px",
            fontWeight: 700,
            letterSpacing: "0.72px",
            textTransform: "uppercase",
            color: "transparent",
            textAlign: "right",
            opacity: 0.7,
            textShadow: "0px 2px 4px rgba(0,0,0,0.08)",
            backgroundImage:
              "linear-gradient(180deg, rgba(255,255,255,1) 10.938%, rgba(255,255,255,0.6) 89.063%)",
            WebkitBackgroundClip: "text",
            backgroundClip: "text",
          }}
        >
          WALLET
        </Text>

        <Text
          fz={10}
          fw={500}
          c="rgba(255,255,255,0.7)"
          style={{ position: "absolute", right: 24, top: 52, lineHeight: "normal" }}
        >
          Available Balance
        </Text>

        <Text
          style={{
            position: "absolute",
            right: 24,
            top: 70,
            lineHeight: "normal",
            textAlign: "right",
            color: "#FFFFFF",
            textShadow: "0px 2px 4px rgba(0,0,0,0.12)",
            fontSize: 24,
            fontWeight: 600,
          }}
        >
          <span style={{ fontSize: 18, fontWeight: 400 }}>₹</span>
          <span style={{ fontSize: 16, fontWeight: 400 }}> </span>
          {formatMoney(walletBalance)}
        </Text>

        <Text
          fz={8}
          fw={600}
          c="rgba(255,255,255,0.5)"
          style={{ position: "absolute", left: 14, bottom: 28, lineHeight: "normal" }}
        >
          CARD HOLDER
        </Text>
        <Text
          fz={12}
          fw={500}
          c="#FFFFFF"
          style={{ position: "absolute", left: 14, bottom: 8, lineHeight: "16px" }}
        >
          {operator?.contact_name}
        </Text>
        <Text
          fz={8}
          fw={600}
          c="rgba(255,255,255,0.5)"
          style={{ position: "absolute", right: 14, bottom: 28, lineHeight: "normal" }}
        >
          VALID UPTO
        </Text>
        <Text
          fz={12}
          fw={500}
          c="#FFFFFF"
          style={{ position: "absolute", right: 14, bottom: 8, lineHeight: "16px" }}
        >
          05/25
        </Text>
      </Card>
      </Group>

    </Box>
  );
};

export default OperatorHeader;